import ListTemplate from "components/ListTemplate";
import React from "react";
import Filters from "./Filters";
import { AddTagsModal, ChangeOwnerModal, ChangeStatusModal, ReplaceTagsModal, BatchDeleteModal } from "components/Tables/MySelection/Modals";
import { cardLayout } from "./cardLayout";
import { mapResponseToFilterValues, mapFilterValuesToInstruction } from "./helpers";
import { useLoaderData } from "react-router";

const CompanyListApp = () => {
  const viewModel = useLoaderData<server.viewmodel.CompanyListFrontModel>();

  return <>
    <ListTemplate
      title={RESX.Company.Companies}
      filterSet="company_List"
      defaultFilters={viewModel.defaultFilters}
      initialInstruction={viewModel.initialInstruction}
      fetchFunction={window.CoreApi.Company.Paginated}
      getId={item => item.companyId}
      layout={cardLayout(viewModel)}
      filters={<Filters initialStatuses={viewModel.statuses} initialTags={viewModel.tags} />}
      functions={{
        mapFilterValuesToInstruction,
        mapResponseToFilterValues
      }}
      options={{
        filterPreset: {
          cacheKey: "company_List",
          listApi: window.CoreApi.FilterPreset.ListFilterPresetsForCompany,
          mutateApi: window.CoreApi.FilterPreset.CreateFilterPresetForCompany
        },
        exportOptions: {
          canExportList: site.permissions.addressBook.canExportList,
          exportOptionsApi: window.CoreApi.Company.ExportOptionsForList
        },
        mySelection: {
          isSelected: item => item.isSelected,
          mainArea: "company",
          batchActions: [{
            label: RESX.Status.ChangeStatus,
            modal: ChangeStatusModal,
            props: { statuses: viewModel.statuses }
          }, {
            label: RESX.Tag.ReplaceTags,
            modal: ReplaceTagsModal,
            props: { tags: viewModel.tags }
          }, {
            label: RESX.Tag.AddTags,
            modal: AddTagsModal,
            props: { tags: viewModel.tags }
          }, {
            label: RESX.Planning.ChangeOwner,
            modal: ChangeOwnerModal
          }, {
            label: RESX.Buttons.btnDeleteAll,
            modal: BatchDeleteModal
          }]
        }
      }}
    />
  </>;
};

export default CompanyListApp;
